import dayjs from 'dayjs';

import { DATE_FORMAT } from '#client/constants/date';

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  compactDisplay: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2
});

export const dateFormatter = (dateString, options) => {
  const date = dayjs(dateString, DATE_FORMAT.CHART);
  if (!date.isValid()) {
    return null;
  }
  const nativeDate = date.toDate();
  const formattedDate = nativeDate.toLocaleString('default', options);
  return formattedDate;
};

export const largeCurrencyAmountFormatter = (number) => {
  const usdValue = number / 100;
  return currencyFormatter.format(usdValue);
};

export const formatHistoryBalance = (balances) => {
  if (!balances || balances.length === 0) {
    return [];
  }

  const formatted = balances.map(({ date, balance }) => ({
    date: dayjs(date).format(DATE_FORMAT.CHART),
    amount: balance?.amount ?? 0
  }));

  if (formatted.length === 1) {
    return [
      {
        date: dayjs(formatted[0].date).subtract(1, 'day').format(DATE_FORMAT.CHART),
        amount: 0
      },
      ...formatted
    ];
  }

  return formatted;
};

export const xTickFormatter = (date) => dateFormatter(date, { month: 'short', day: 'numeric' });
export const yTickFormatter = (number) => {
  const usdValue = number / 100;
  return currencyFormatter.format(usdValue);
};

export const calculateDomainAndTicks = (dailyBalance) => {
  const MIN_CHECK_AMOUNT = 99900;

  const minAmount = Math.min(...dailyBalance.map((item) => item.amount));
  const maxAmount = Math.max(...dailyBalance.map((item) => item.amount));

  if (dailyBalance.length === 0 || maxAmount < MIN_CHECK_AMOUNT) {
    return { yTicks: null, yDomain: ['auto', 'auto'] };
  }

  // create 5 point between minAmount and maxAmount
  const step = (maxAmount - minAmount) / 4;
  const steps = new Set(
    [minAmount, minAmount + step, minAmount + 2 * step, minAmount + 3 * step, maxAmount].map(
      yTickFormatter
    )
  );

  const averageAmount = (minAmount + maxAmount) / 2;
  const isMissSteps = steps && steps.size < 5;

  const yTicks = isMissSteps ? [0.9, 0.95, 1, 1.05, 1.1].map((item) => averageAmount * item) : null;

  const yDomain = isMissSteps ? [0.9, 1.1].map((item) => averageAmount * item) : ['auto', 'auto'];

  return { yTicks, yDomain };
};
